import { z } from "zod";

export const SuggestionOverrideDecisionSchema = z.enum({
  PROMOTE: "promote",
  DROP: "drop",
});

export type SuggestionOverrideDecisionType = z.infer<
  typeof SuggestionOverrideDecisionSchema
>;

export const SuggestionOverrideDecision = SuggestionOverrideDecisionSchema.enum;
